<div
    class="py-3"
    [formGroup]="form()">
    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="name"
            required="true"
            focus="true"
            label="Room Group Name" />

        <name-validation-errors
            [formGroup]="form()"
            id="name"
            label="Room Group Name" />
    </div>
</div>